import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISPOSTA_SOLLECITO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlRispostaSollecitoState extends EntityState<IID_OL_RISPOSTA_SOLLECITO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RISPOSTA_SOLLECITO })
@InterfaceDataStore(InterfaceName.RISPOSTA_SOLLECITO)
export class IIDolRispostaSollecitoStore extends EntityStore<IIdOlRispostaSollecitoState> {
  constructor() {
    super([]);
  }
}
